import { ReactElement } from "react";

import {
  ApplicationAuthorisationGuard,
  ModuleGuardProps,
} from "../../../shared/auth/guards/application-authorisation.guard";
import { useHasCcfAccess } from "./use-has-ccf-access";

/** CCF's own guard component. See `application-authorisation.guard.tsx` for why each module has one. */
export const CcfAuthorisationGuard = ({ children }: ModuleGuardProps): ReactElement => {
  const hasAccess = useHasCcfAccess();

  return <ApplicationAuthorisationGuard hasAccess={hasAccess}>{children}</ApplicationAuthorisationGuard>;
};
